import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: 'KAHON.PH | The Space Makers',
      metaTags: [{
          name: 'description',
          content: 'Kahon.ph offers affordable and flexible storage solutions with our storage boxes and spaces for rent. Our services are available to the Greater Manila area: Quezon City, Makati, Taguig, Manila, Pasig, and more'
        },
        {
          property: 'og:description',
          content: 'Kahon.ph offers affordable and flexible storage solutions with our storage boxes and spaces for rent. Our services are available to the Greater Manila area: Quezon City, Makati, Taguig, Manila, Pasig, and more'
        }
      ]
    }
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import( /* webpackChunkName: "about" */ "../views/About.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;